export type FeaturedProject = {
  id: string
  name: string
  tagline: string
  href: string
  image: string
  destinationId: "engineering" | "ai" | "creative" | "music"
}

/** In-scene destination cards (hyperspace worlds). */
export const FEATURED_PROJECTS: FeaturedProject[] = [
  {
    id: "orchestrator",
    name: "ORCHESTRATOR",
    tagline: "Tickets, agents, and automation in one control panel.",
    href: "https://getorchestrator.app",
    image: "/projects/orchestrator-desk.jpg",
    destinationId: "engineering",
  },
  {
    id: "black-velvet",
    name: "BLACK VELVET RECORDS",
    tagline: "Music discovery, Song Wars, and artist hubs.",
    href: "#black-velvet-records",
    image: "/images/portfolio/black-velvet-records/bvr-home.webp",
    destinationId: "creative",
  },
  {
    id: "gamedna",
    name: "GAMEDNA",
    tagline: "Sports intelligence, games, and AI prediction.",
    href: "#gamedna",
    image: "/images/portfolio/gamedna/gamedna-home.webp",
    destinationId: "ai",
  },
  {
    id: "bvr-tools",
    name: "BVR FLOW + VOLT",
    tagline: "Creative technology for music production.",
    href: "#bvr",
    image: "/images/portfolio/bvr/bvr-flow.webp",
    destinationId: "music",
  },
]

export function projectForDestination(
  destinationId: string | undefined,
): FeaturedProject | null {
  if (!destinationId) return null
  return FEATURED_PROJECTS.find((p) => p.destinationId === destinationId) ?? null
}
